import FormControl, { FormControlProps } from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormHelperText from '@mui/material/FormHelperText';
import FormLabel from '@mui/material/FormLabel';
import { ReactNode } from 'react';
import { Tooltip } from '../display';

export default function FieldWrapper({
  children,
  errorText,
  helperText,
  inlineLabel = false,
  label,
  sx,
  tooltip,
  ...rest
}: FieldWrapperProps) {
  const error = Boolean(errorText);
  const errorOrHelperText = errorText || helperText;

  return (
    <Tooltip title={tooltip}>
      <FormControl error={error} sx={{ mt: 2, ...sx }} {...rest}>
        {inlineLabel && (
          <FormControlLabel
            control={<>{children}</>}
            label={
              <>
                {label}
                {Boolean(errorOrHelperText) && (
                  <FormHelperText sx={{ ml: 0 }}>
                    {errorOrHelperText}
                  </FormHelperText>
                )}
              </>
            }
          />
        )}

        {!inlineLabel && (
          <>
            <FormLabel component="legend" error={error}>
              {label}
            </FormLabel>
            {children}
            {Boolean(errorOrHelperText) && (
              <FormHelperText sx={{ ml: 0 }}>
                {errorOrHelperText}
              </FormHelperText>
            )}
          </>
        )}
      </FormControl>
    </Tooltip>
  );
}

export interface FieldWrapperProps extends FormControlProps {
  errorText?: ReactNode;
  helperText?: ReactNode;
  inlineLabel?: boolean;
  label?: string;
  tooltip?: string;
}
